import { Stack, TextField } from '@mui/material'
import PaduConfig from './PaduConfig'
import { EditorField } from './schemaEditorReducer'

interface P {
    field: EditorField
    onUpdateField: (
        fieldId: string,
        updates: Partial<EditorField>
    ) => void
}

const NumberFieldConfig = ({ field, onUpdateField }: P) => {
    return (
        <Stack spacing={2}>

            {/* Minimum / Maximum row */}
            <Stack direction='row' spacing={2}>
                <TextField
                    disabled={field.isDefault}
                    fullWidth
                    size='small'
                    label='Minimum value'
                    type='number'
                    value={field.validation?.min ?? ''}
                    onChange={e =>
                        onUpdateField(field._id, {
                            validation: {
                                ...field.validation,
                                min: e.target.value === '' ? undefined : Number(e.target.value) }
                        })}
                />

                <TextField
                    disabled={field.isDefault}
                    fullWidth
                    size='small'
                    label='Maximum value'
                    type='number'
                    value={field.validation?.max ?? ''}
                    onChange={e =>
                        onUpdateField(field._id, {
                            validation: {
                                ...field.validation,
                                max: e.target.value === '' ? undefined : Number(e.target.value) }
                        })}
                />
            </Stack>

            {/* Pattern */}
            <TextField
                disabled={field.isDefault}
                fullWidth
                size='small'
                label='Pattern'
                value={field.validation?.pattern ?? ''}
                onChange={e =>
                    onUpdateField(field._id, { validation: {
                        ...field.validation,
                        pattern: e.target.value === '' ? undefined : e.target.value }
                    })}
            />
            <PaduConfig
                field={field}
                onUpdateField={onUpdateField}
            />

        </Stack>
    )
}

export default NumberFieldConfig
